<template>
  <div class="tracking">
    <BLoading
      :is-full-page="true"
      :active="true"
      :can-cancel="false"
    />
  </div>
</template>

<script>
export default {
  name: 'Tracking',
  mounted() {
    window.addEventListener('load', () => {
      if (window.ga && window.ga.create) {
        window.location.replace(this.$route.query.redirect);
      }
    }, false);
  },
};
</script>

<style scoped>
</style>
